module.exports = __webpack_public_path__ + "static/testi-1-2265135ed44baccbe8efb810c7d406f9.jpg";